module.exports = __webpack_public_path__ + "img/bg_black_.17fa4b54.png";